import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable} from "rxjs";
import {inject} from "@angular/core";
import {League, LeagueFilter, PagedFilter, Pages} from "@model";
import {LeagueService} from "@services";
import {SERIES_ROUTE} from "../app-routing.module";

export const LeaguesReslover: ResolveFn<Observable<League[]> | League[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  leagueService: LeagueService = inject(LeagueService)
): Observable<League[]> | League[] => {
  return leagueService.findLeagues();
};

export const LeagueReslover: ResolveFn<Observable<League | undefined> | League | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  leagueService: LeagueService = inject(LeagueService)
): Observable<League | undefined> | League | undefined => {
  return leagueService.fetchLeague(+route.queryParams['leagueId']);
};

export const LeaguePublicResolover: ResolveFn<Observable<League | undefined> | League | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  leagueService: LeagueService = inject(LeagueService)
): Observable<League | undefined> | League | undefined => {
  return leagueService.fetchPublicLeague(+route.queryParams['leagueId']);
};

export function createLeagueCalendarResolver(): ResolveFn<Observable<League[]> |
  Promise<League[]> | League[] | []> {
  return (route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot,
          leagueService: LeagueService = inject(LeagueService),
          router: Router = inject(Router)):
    Observable<League[]> |
    Promise<League[]> | League[] | [] => {

    let [leagueFilter, paramsValid]: [LeagueFilter, boolean] = getParams(route);
    if (!paramsValid) {
      router.navigate([SERIES_ROUTE])
      return EMPTY;
    }

    return leagueService.findPublicLeagues(new PagedFilter(new Pages(), leagueFilter));
  };
}

function getParams(route: ActivatedRouteSnapshot): [LeagueFilter, boolean] {
  let valid: boolean = true;
  let leagueFilter: LeagueFilter = LeagueFilter.leagueCalendarParams();

  let sportId: number = +route.queryParams["sport"];
  let countryId: number = +route.queryParams["country"];
  let name = route.queryParams["name"] ? route.queryParams["name"] : "";
  let dateFrom = route.queryParams["dateFrom"];
  let dateTo = route.queryParams["dateTo"];
  let dateFromParam: Date | undefined = leagueFilter.startDateFrom;
  let dateToParam: Date | undefined = leagueFilter.startDateTo;
  if (dateFrom) {
    if (!isNaN((new Date(dateFrom)).getTime())) {
      dateFromParam = new Date(dateFrom);
    }
  }
  if (dateTo) {
    if (!isNaN((new Date(dateTo)).getTime())) {
      dateToParam = new Date(dateTo)
    }
  }
  if (dateFromParam && dateToParam) {
    valid = dateFromParam.getTime() < dateToParam.getTime();
  }
  if (valid) {
    leagueFilter.startDateFrom = dateFromParam;
    leagueFilter.startDateTo = dateToParam;
  }

  if (name && name.trim().length > 0) {
    leagueFilter.name = name
  }
  if (sportId) {
    leagueFilter.sportId = sportId;
  }
  if (countryId) {
    leagueFilter.countryId = countryId;
  }
  return [leagueFilter, valid];
}
